<div class="row w-100 mx-0">
    
    <div [ngClass]="getRowClass()" *ngFor="let item of items">
                    
        <div class="card text-center h-100 mb-3" [ngClass]="item.customClass" >
            <img *ngIf="item.image" [src]="item.image.path" [ngClass]="item.image.customClass" class="img-fluid card-img-top mx-auto pt-2" >
            <div class="card-body">
                <h5 class="card-title" [innerHTML]="item.title"></h5>
                <p class="card-text"   [innerHTML]="item.text"></p>
                <p *ngIf="item.button.text != null" class="card-text">
                    <a mat-raised-button class="custom-card-list-item-button" [innerHTML]="item.button.text" [href]="item.button.link"></a>
                </p>
            </div>
        </div>

    </div>
    
</div>
